import React from "react";
import { ScentButton } from "./ScentButton";
import { ScentDetails } from "@/store";
import { usePdpFocusedScent, usePdpScents } from "./PdpContext";

export const ScentSelector = ({
  focusedScent,
  showBottomPart = true,
  pdpShowScentTestVariant = false,
}: {
  focusedScent: ScentDetails;
  showBottomPart?: boolean;
  pdpShowScentTestVariant?: boolean;
}) => {
  const scents = usePdpScents();
  focusedScent = usePdpFocusedScent() || focusedScent;
  // Calculate height of description to fit 2 lines of text so when
  // someone is hovering over the scents there is no layout shift.
  // line-height is 125% so we convert it into 1.25 for css calc.
  const scentHeight = `calc(var(--font-size-sm) * 1.25 * 2)`;

  return (
    <div className="flex flex-col">
      <ul className={pdpShowScentTestVariant ? "flex max-w-full flex-wrap gap-2 pr-4" : "flex space-x-2 pb-2"}>
        {scents.map((x) => (
          <li key={x.name}>
            <ScentButton
              scent={x}
              focused={x == focusedScent}
              showScentName={pdpShowScentTestVariant}
              highlightUnfocused={!pdpShowScentTestVariant}
            />
          </li>
        ))}
      </ul>
      {showBottomPart ? (
        <>
          <p className="body focused-scent-name-bottom">
            <span className="font-semibold">Scent: </span>
            <span>{focusedScent.name}</span>
          </p>
          <div className="mb-2" style={{ minHeight: scentHeight }}>
            <p className="m-0 text-sm text-gray-700">
              {focusedScent.description}
            </p>
          </div>
        </>
      ) : null}
    </div>
  );
};
